import React from 'react'
import Select from 'react-select';
import {estados} from '../../util/constantsUtil';

const Estados =  ({event, handleEstado}) =>
    <div>
        <Select
            {...event.input}
            noOptionsMessage={() => ('Nenhuma opção encontrada')}
            placeholder='Selecione o estado...'
            options={estados.map(elemento => ({
                label: `${elemento.nome}-${elemento.uf}`,
                value: elemento.uf
            }))}
            onChange={value => {
                handleEstado(value);
                event.input.onChange(value)
            }}
            onBlur={() => event.input.onBlur()}
        />
        {event.meta.touched
        && (event.meta.error && <span style={{ color: 'red' }}>{event.meta.error}</span>)}
    </div>;

export default Estados
